import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-tree-add-btn',
  templateUrl: './tree-add-btn.component.html',
  styleUrls: ['./tree-add-btn.component.css']
})
export class TreeAddBTNComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  @Input() Primary:boolean;
  @Input() Text:string='';

}
